import { useState } from 'react'
import { Globe, Check } from 'lucide-react'
import { useToast } from '../../hooks/useToast'

/**
 * Language Settings Tab - GJYL Dashboard Style
 */

const languages = [
  { code: 'en', name: 'English', native: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', native: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', native: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', native: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt', name: 'Portuguese', native: 'Português', flag: '🇧🇷' },
  { code: 'ja', name: 'Japanese', native: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', native: '한국어', flag: '🇰🇷' },
  { code: 'zh', name: 'Chinese', native: '中文', flag: '🇨🇳' },
  { code: 'ru', name: 'Russian', native: 'Русский', flag: '🇷🇺' },
  { code: 'it', name: 'Italian', native: 'Italiano', flag: '🇮🇹' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polish', native: 'Polski', flag: '🇵🇱' },
]

export default function LanguageTab({ profile, onUpdateProfile }) {
  const toast = useToast()
  const [selectedLanguage, setSelectedLanguage] = useState('en')

  const handleLanguageChange = (code) => {
    setSelectedLanguage(code)
    const lang = languages.find(l => l.code === code)
    toast.success(`Language changed to ${lang?.name}`)
    // In production, this would trigger i18n locale change
  }

  return (
    <div className="space-y-8">
      {/* Language Selection */}
      <div className="p-6 bg-gray-800/40 backdrop-blur-sm rounded-2xl border border-gray-700/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-indigo-500/20 flex items-center justify-center">
            <Globe className="w-5 h-5 text-indigo-400" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-white">Display Language</h3>
            <p className="text-sm text-gray-400">Choose your preferred language</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mt-6">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`
                flex items-center gap-3 p-4 rounded-xl border transition-all duration-200
                ${selectedLanguage === lang.code
                  ? 'bg-indigo-600/20 border-indigo-500/50 text-white'
                  : 'bg-gray-800/40 border-gray-700/30 text-gray-300 hover:bg-gray-700/40 hover:text-white'
                }
              `}
            >
              <span className="text-2xl">{lang.flag}</span>
              <div className="flex-1 text-left">
                <div className="text-sm font-medium">{lang.name}</div>
                <div className="text-xs text-gray-500">{lang.native}</div>
              </div>
              {selectedLanguage === lang.code && (
                <Check className="w-5 h-5 text-indigo-400" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Coming Soon Note */}
      <div className="p-4 bg-gray-800/20 rounded-xl border border-gray-700/20">
        <p className="text-sm text-gray-500 text-center">
          More languages coming soon. Want to help translate GJYL?{' '}
          <a href="#" className="text-indigo-400 hover:underline">Join our community</a>
        </p>
      </div>
    </div>
  )
}
